import { Box, Chip, Container, Typography } from '@mui/material';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import React from 'react';
import styled from 'styled-components';
import History from '../../history/History';

const UserHistory = ({ user }) => {
    const stats = [
        {
            label: 'Realizadas',
            value: user?.games_count ?? 0,
            icon: <SportsEsportsOutlinedIcon />,
        },
        {
            label: 'Pendientes',
            value: user?.moves ?? 0,
            icon: <HourglassTopOutlinedIcon />,
        },
        {
            label: 'Ganadoras',
            value: user?.games_win_count ?? 0,
            icon: <EmojiEventsOutlinedIcon />,
        },
        {
            label: 'Total códigos',
            value: user?.codes_total ?? 0,
            icon: <ConfirmationNumberOutlinedIcon />,
        },
    ];

    return (
        <Wrapper>
            <StatsGrid>
                {stats.map((item) => (
                    <StatItem key={item.label}>
                        <Box className="icon">
                            {item.icon}
                        </Box>

                        <Box>
                            <strong>{item.value}</strong>
                            <span>{item.label}</span>
                        </Box>
                    </StatItem>
                ))}
            </StatsGrid>

            <HistoryWrapper>
                <History user_search={user?.uuid} />
            </HistoryWrapper>
        </Wrapper>
    );
};

export default UserHistory;

const Wrapper = styled(Container)`
    padding: 0 !important;
    max-width: 100% !important;
`;

const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.5rem;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

const StatItem = styled.div`
    padding: 0.3rem;
    border-radius: 16px;
    background: rgba(16, 40, 95, 0.045);
    border: 1px solid rgba(15, 34, 77, 0.08);
    display: flex;
    align-items: center;
    gap: 0.75rem;

    .icon {
        width: 42px;
        height: 42px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #10285f;
        background: rgba(214, 170, 58, 0.16);
        border: 1px solid rgba(214, 170, 58, 0.28);
        flex-shrink: 0;

        svg {
            font-size: 1.25rem;
        }
    }

    strong {
        display: block;
        color: #10285f;
        font-size: 1.1rem;
        font-weight: 900;
        line-height: 1.1;
    }

    span {
        display: block;
        margin-top: 0.1rem;
        color: rgba(15, 34, 77, 0.58);
        font-size: 0.78rem;
        font-weight: 700;
    }
`;

const HistoryWrapper = styled.div`
    width: 100%;
`;